<div class="img-header">
    <mat-icon (click)="guiService.goTo('main/home')" svgIcon="mat:arrow_back_ios"></mat-icon>
  <img [src]="environment.workout_programs+'/'+program?._id+'/images/main'" *ngIf="program?._id">
</div>
<div class="container">
  <div class="program-title">
    <h2>{{program?.i18nName[translate.currentLang.toUpperCase()]}}</h2>
    <span class="week-chip">
      <p>{{"HOME.WEEK" | translate }} {{guiService?.userLogged?.workoutInfo.programs[guiService?.currentProgram?._id].week}}</p>
    </span>
  </div>
  <div class="accordion-container">
    <div class="custom-accordion" *ngFor="let week of program?.weeks; let k = index">
      <div class="accordion-header">
        <div class="week-n">
          <div class="custom-radio" (click)="selectedWeek = k; openedWeek = k">
            <div class="inner-radio" *ngIf="k === selectedWeek"></div>
          </div>
          <p>{{"HOME.WEEK" | translate }} {{k}}</p>
        </div>
        <mat-icon svgIcon="mat:arrow_drop_down" (click)="openedWeek = k" *ngIf="k !== openedWeek"></mat-icon>
        <mat-icon svgIcon="mat:arrow_drop_up" *ngIf="k === openedWeek"></mat-icon>
      </div>
      <div class="workouts-slider" *ngIf="k === openedWeek">
        <swiper-container [slidesPerView]="2.5">
          <swiper-slide
            *ngFor="let workout of program?.weeks[openedWeek] | keyvalue; let i = index">
            <div class="workout-slide">
              <div class="workout-day">
                <p>{{"HOME.DAY" | translate}} {{i+1}}</p>
                <div class="mark-icon-placeholder" *ngIf="!getWorkoutValue(workout)?.id"></div>
              </div>
              <div class="inner">
                <img class="workout-img" *ngIf="getWorkoutValue(workout)?.id" [src]="environment.workouts+'/'+getWorkoutValue(workout)?.id+'/images/main'">
                <img class="workout-img" *ngIf="!getWorkoutValue(workout)?.id" src="../../assets/img/rest.png">
              </div>
              <p class="workout-name"*ngIf="getWorkoutValue(workout)?.name">{{getWorkoutValue(workout)?.name[translate.currentLang.toUpperCase()]}}</p>
              <p class="workout-name" *ngIf="!getWorkoutValue(workout)?.name">{{"HOME.REST" | translate}}</p>
            </div>
          </swiper-slide>
        </swiper-container>
      </div>
    </div>
  </div>
</div>
<div class="footer-position">
    <button class="its-button change-week-btn-modal-tutorial" (click)="changeWeek()">{{"GENERIC.CONTINUE" | translate}}</button>
  </div>
